import { __awaiter } from "tslib";
export var NsCollapsePanelModel;
(function (NsCollapsePanelModel) {
    NsCollapsePanelModel.id = 'COLLAPSE_PANEL_DATA';
    NsCollapsePanelModel.useModel = (model) => __awaiter(this, void 0, void 0, function* () {
        return model.awaitModel(NsCollapsePanelModel.id);
    });
})(NsCollapsePanelModel || (NsCollapsePanelModel = {}));
//# sourceMappingURL=interface.js.map